// Разбор вставки с сайта ФССП (банк данных ИП) — общий для карточки клиента банкротства и гражданского дела.
export function parseRuDate(str) { if (!str) return null; const m=str.match(/(\d{2})\.(\d{2})\.(\d{4})/); if(m) return `${m[3]}-${m[2]}-${m[1]}`; return str; }
export function parseFssp(text) {
  const records = [];
  const ipPattern = /(\d{1,6}\/\d{2}\/\d{5}-ИП)\s+от\s+(\d{2}\.\d{2}\.\d{4})/g;
  const matches = [...text.matchAll(ipPattern)];
  if (!matches.length) return records;
  for (let i = 0; i < matches.length; i++) {
    const m = matches[i];
    const start = m.index;
    const end = i + 1 < matches.length ? matches[i+1].index : text.length;
    const block = text.substring(start, end);
    const ipNumber = m[1];
    const ipDate = parseRuDate(m[2]);

    // Court act + organ - unified extraction
    let courtAct = '';
    let courtOrgan = '';

    // Исполнительная надпись нотариуса
    const inMatch = block.match(/Исполнительная надпись нотариуса от (\d{2}\.\d{2}\.\d{4})\s*№\s*([\wА-Яа-я\d\-\/]+)/);
    if (inMatch) {
      courtAct = 'Исполнительная надпись нотариуса от ' + inMatch[1] + ' № ' + inMatch[2];
      const notaryMatch = block.match(/НОТАРИУС\s+([А-ЯЁ][А-ЯЁа-яё]+\s+[А-ЯЁ][А-ЯЁа-яё]+\s+[А-ЯЁ][А-ЯЁа-яё]+)/);
      courtOrgan = notaryMatch ? 'НОТАРИУС ' + notaryMatch[1].trim() : 'НОТАРИУС';
    }

    // Pattern: "Судебный приказ от DD.MM.YYYY № XXXX ОРГАН_ЗАГЛАВНЫМИ"
    if (!courtAct) {
      const spMatch = block.match(/Судебный приказ от (\d{2}\.\d{2}\.\d{4})\s*№\s*([\wА-Яа-я\d\-\/#]+)\s+([А-Я][А-Я\s№\d\.]+?(?:БАШКОРТОСТАН|БАШКИРИИ|РАЙОНА|ОБЛАСТИ|КРАЯ|РЕСПУБЛИКИ)[А-Я\s]*)/);
      if (spMatch) {
        courtAct = 'Судебный приказ от ' + spMatch[1] + ' № ' + spMatch[2];
        courtOrgan = spMatch[3].trim();
      }
    }

    // Исполнительный лист
    if (!courtAct) {
      const ilMatch = block.match(/Исполнительный лист от (\d{2}\.\d{2}\.\d{4})\s*№\s*([А-Яа-яA-Za-z\s]*\d[\w\d\s]*?)\s+([А-Я][А-Я\s№\d\.]+?(?:БАШКОРТОСТАН|РАЙОНА|ОБЛАСТИ|КРАЯ|РЕСПУБЛИКИ|СУДА?)[А-Я\s]*)/);
      if (ilMatch) {
        courtAct = 'Исполнительный лист от ' + ilMatch[1] + ' № ' + ilMatch[2].trim();
        courtOrgan = ilMatch[3].trim();
      }
    }

    // Постановление пристава
    if (!courtAct) {
      const ppMatch = block.match(/Постановление судебного пристава-исполнителя от (\d{2}\.\d{2}\.\d{4})\s*№\s*([\w\d\/]+)\s+([А-Я][А-Я\s№\d\.]+?(?:БАШКОРТОСТАН|РАЙОНА|ОБЛАСТИ|КРАЯ|РЕСПУБЛИКИ|ПРИСТАВОВ)[А-Я\s]*)/);
      if (ppMatch) {
        courtAct = 'Постановление от ' + ppMatch[1] + ' № ' + ppMatch[2];
        courtOrgan = ppMatch[3].trim();
      }
    }

    // Fallback - simpler patterns
    if (!courtAct) {
      const fb = block.match(/(Судебный приказ от \d{2}\.\d{2}\.\d{4}\s*№\s*[\wА-Яа-я\d\-\/#]+)/);
      if (fb) courtAct = fb[1].trim();
    }
    if (!courtAct) {
      const fb2 = block.match(/(Исполнительная надпись нотариуса от \d{2}\.\d{2}\.\d{4}\s*№\s*[\wА-Яа-я\d\-\/]+)/);
      if (fb2) courtAct = fb2[1].trim();
    }

    let debtAmount = 0;
    const dm = block.match(/Сумма долга:\s*([\d\s]+[.,]\d{2})\s*руб/);
    if (dm) debtAmount = parseFloat(dm[1].replace(/\s/g,'').replace(',','.'));
    const rm = block.match(/Остаток долга[^:]*:\s*([\d\s]+[.,]\d{2})\s*руб/);
    if (rm) debtAmount = parseFloat(rm[1].replace(/\s/g,'').replace(',','.'));

    let fee = 0;
    const fm = block.match(/Исполнительский сбор:\s*([\d\s]+[.,]\d{2})\s*руб/);
    if (fm) fee = parseFloat(fm[1].replace(/\s/g,'').replace(',','.'));

    let oblType = 'Иное';
    if (block.includes('кредитным платежам')) oblType = 'Кредит';
    else if (block.includes('платежам за жилую') || block.includes('коммунальные платежи')) oblType = 'Коммунальные услуги';
    else if (block.includes('платежам за газ') || block.includes('электроэнерг')) oblType = 'Коммунальные услуги';
    else if (block.includes('налогов и сборов')) oblType = 'Налоги';
    else if (block.match(/Исполнительский сбор(?!:)/)) oblType = 'Исполнительский сбор';

    // ИНН взыскателя — отдельной строкой под органом, выдавшим документ (дальше дата окончания / основание / предмет)
    const innM = block.match(/(?:^|[\n\r])[ \t]*(\d{10}|\d{12})(?=\s|$)/) ||
      block.match(/\s(\d{10}|\d{12})\s+(?:\d{2}\.\d{2}\.\d{4}\s+)?(?:ст\.|Задолженност|Исполнительск|Иные|Штраф|Налог|Взыскани)/);
    const creditorInn = innM ? innM[1] : '';

    let closeStatus = '';
    const csm = block.match(/ст\.\s*4[67]\s*ч\.\s*1\s*п\.\s*(\d)/);
    if (csm) closeStatus = 'п.' + csm[1];

    let bailiff = '';
    const bm = block.match(/,([А-ЯЁ][А-ЯЁа-яё]+\s+[А-ЯЁ]\.\s*[А-ЯЁ]\.)\s*\+7/) || block.match(/([А-ЯЁ]{2,}\s+[А-ЯЁ]\.\s*[А-ЯЁ]\.)\s*\+7/);
    if (bm) bailiff = bm[1].trim();

    records.push({
      ip_number: ipNumber, ip_date: ipDate,
      creditor_name: '', creditor_inn: creditorInn,
      court_act: courtAct, court_organ: courtOrgan,
      contract_num: '', contract_date: null,
      debt_amount: debtAmount, fee: fee, bailiff: bailiff,
      status: 'active', obligation_type: oblType,
      close_status: closeStatus
    });
  }
  // Дедупликация по ip_number — каждое ИП уникально
  const byIp = {};
  for (const r of records) {
    if (!byIp[r.ip_number]) byIp[r.ip_number] = r;
  }
  const uniqByIp = Object.values(byIp);

  // Дедупликация по court_act: приоритет — активный ИП (нет close_status), среди равных — больший долг
  const byAct = {};
  function actScore(r) {
    const isActive = !r.close_status || r.close_status === '';
    return (isActive ? 1000000000 : 0) + (Number(r.debt_amount) || 0);
  }
  for (const r of uniqByIp) {
    const key = r.court_act ? r.court_act.trim() : null;
    if (!key) { byAct['__no_act_' + r.ip_number] = r; continue; }
    if (!byAct[key] || actScore(r) > actScore(byAct[key])) byAct[key] = r;
  }
  return Object.values(byAct);
}
